import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Head from '../../components/head';
import ItemBox from '../../components/shared/item_box';
import Item from '../../components/itens/item'


function AuxilioMacucoScreen() {
    return (
        <Fragment>
            <Head titulo="Auxílio Macuco" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/social'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />

                <ItemBox
                    titulo={"Programa Auxílio Macuco"}
                    texto={[<Fragment><strong>Finalidade do Serviço:</strong><br />
                        <p>A Secretaria Municipal de Desenvolvimento Social e Direitos Humanos realiza o cadastramento de
                            famílias no Cadastro Único para Programas Sociais do Governo Federal - CadÚnico. O Cadastro
                            Único é requisito para diferentes Programas Sociais: Programa Auxílio Brasil, Minha Casa Minha
                            Vida, Tarifa Social de Energia Elétrica, Auxílio Macuco, entre outros.</p><br />
                        <strong>Requisitos Necessários para os Usuários:</strong><br />
                        <p>Documentação de cada membro da família que será cadastrado no Cadastro Único:</p>
                        <p>Documento de identificação (RG, CNH, Certidão de Nascimento ou Casamento);</p>
                        <p>CPF;</p>
                        <p>Título de Eleitor, caso possua;</p>
                        <p>Carteira de Trabalho, caso possua;</p>
                        <p>Comprovante de residência (conta de água, luz, telefone ou contrato de aluguel);</p>
                        <p>Comprovante de matrícula das crianças e adolescentes na escola;</p>
                        <p>Comprovante de frequência escolar de todas as crianças e adolescentes de 06 a 15 anos;</p>
                        <p>Documento de identificação e CPF do responsável pela família.</p>
                        <p>O cadastramento é realizado preferencialmente nos Centros de Referência de Assistência Social
                            (CRAS) mediante agendamento prévio.</p><br />
                        <strong>Etapas do Processo:</strong><br />
                        <p>Acolhimento.</p>
                        <p>Verificação dos documentos.</p>
                        <p>Preenchimento do Cadastro Único.</p>
                        <p>Entrega do comprovante de cadastro.</p>
                        <p>Orientações sobre programas sociais.</p><br />
                        <strong>Tempo de Atendimento:</strong><br />
                        <p>Imediato, exceto em casos de necessidade de agendamento prévio.</p><br />
                        <strong>Local:</strong><br />
                        <p>CRAS Terezinha Pinheiro Martinelli</p>
                        <p>Rua Professora Adilva Figueiredo Costa, nº126, Santos Reis, Macuco – RJ</p>
                        <p>Cep.: 285445-000</p>
                        <p>Telefone: 22 2554-1703</p>
                        <p>smdsdh.macuco@gmail.com</p>
                        <p>CRAS Rosangela Gomes Pacheco</p>
                        <p>Rua Henrique Frederico Ribeiro, nº14, Paraíso, Macuco – RJ</p>
                        <p>Cep.:28545-000</p>
                        <p>Telefone: 22 2554-5903</p>
                        <p>cras2.paraiso@hotmail.com</p><br /></Fragment>]}
                />

                <Item
                    titulo={"Lei nº1012"}
                    descricao={"Veja aqui aqui a legislação sobre o Programa Auxílio Macuco na íntegra"}
                    awesome={"faScaleBalanced"}
                    link={"https://prefeituramacuco.rj.gov.br/transparencia/arquivos/lei/2021/Lei1012.pdf"}
                    key={1}
                />

            </Container>
            <Footer />
        </Fragment>
    );
}

export default AuxilioMacucoScreen;